import Icons, { IconsProps } from '../../Icons';

export type ErrorProps = IconsProps;

// https://www.zhangxinxu.com/sp/svgo/
// https://jakearchibald.github.io/svgomg/

export function Error(props: ErrorProps) {
  return (
    <Icons {...props}>
      <path
        fill={props.color}
        d="M12 16.45a.623.623 0 0 0 .438-.175.56.56 0 0 0 .187-.425.589.589 0 0 0-.187-.45.623.623 0 0 0-.438-.175.623.623 0 0 0-.438.175.589.589 0 0 0-.187.45.56.56 0 0 0 .187.425.623.623 0 0 0 .438.175Zm-.5-3.3h1v-6h-1v6ZM12 21c-1.25 0-2.42-.237-3.512-.712a9.142 9.142 0 0 1-2.85-1.926 9.143 9.143 0 0 1-1.926-2.85A8.709 8.709 0 0 1 3 12c0-1.25.237-2.421.712-3.513a9.159 9.159 0 0 1 1.926-2.85 9.152 9.152 0 0 1 2.85-1.925A8.709 8.709 0 0 1 12 3c1.25 0 2.421.237 3.513.712a9.168 9.168 0 0 1 2.85 1.925 9.167 9.167 0 0 1 1.925 2.85A8.715 8.715 0 0 1 21 12c0 1.25-.237 2.42-.712 3.512a9.151 9.151 0 0 1-1.925 2.85 9.158 9.158 0 0 1-2.85 1.926A8.715 8.715 0 0 1 12 21Zm0-1c2.233 0 4.125-.775 5.675-2.325C19.225 16.125 20 14.233 20 12c0-2.233-.775-4.125-2.325-5.675C16.125 4.775 14.233 4 12 4c-2.233 0-4.125.775-5.675 2.325C4.775 7.875 4 9.767 4 12c0 2.233.775 4.125 2.325 5.675C7.875 19.225 9.767 20 12 20Z"
      />
    </Icons>
  );
}
